module.exports = __webpack_public_path__ + "img/logo-234x100.c8ab275d.jpg";